import type { Locale } from '@faceup/ui-base'
import { DEFAULT_LANGUAGE, type Language } from '@faceup/utils'
import { createContext } from 'react'

export type TextDirection = 'ltr' | 'rtl'

type LanguageContextProps = {
  language: Language
  messages: Record<string, string>
  antLocale: Locale | undefined
  direction: TextDirection
}

export const LanguageContext = createContext<LanguageContextProps>({
  language: DEFAULT_LANGUAGE,
  messages: {},
  antLocale: undefined,
  direction: 'ltr',
})
